import notepadSvg from 'assets/icons/notepad.svg';
import { Color } from 'lib/Button';
import DropdownMenu from 'lib/DropdownMenu';

interface DealFormDropdownProps {
  openPlanner: () => void;
  openDealForm: () => void;
}

const DealFormDropdown = ({ openPlanner, openDealForm }: DealFormDropdownProps): React.ReactElement => {
  const frontEndPreference = localStorage.getItem('preference');

  const plannerOption = {
    id: 'planner-native',
    onClick: openPlanner,
    label: 'Planner',
    dataPendoId: '/deals | Create planner deal',
  };
  const dealFormOption = {
    id: 'deal-form',
    onClick: openDealForm,
    label: 'Deal form',
    dataPendoId: '/deals | Create deal form',
  };

  const frontEndDropdownChoice = frontEndPreference ? [plannerOption, dealFormOption] : [dealFormOption, plannerOption];

  return (
    <DropdownMenu
      dropdownMenuOptions={frontEndDropdownChoice}
      icon={notepadSvg}
      label="Create campaign"
      color={Color.PRIMARY}
    />
  );
};

export default DealFormDropdown;
